<div class="dialog-wrapper">
  <h2 mat-dialog-title>{{ data.title | translate }}</h2>
  <div mat-dialog-content>
    <span class="text">{{ data.text | translate }}</span>
    <mat-form-field appearance="outline" *ngIf="data.type == 'prompt'">
      <input type="text" matInput [(ngModel)]="data.value">
    </mat-form-field>
  </div>
  <ul *ngIf="data.list?.length >0">
    <li *ngFor="let item of data.list">{{item}}</li>
  </ul>
  <div mat-dialog-actions>
    <div style="width: 100%; text-align: center">
      <div style="width: 100%; text-align: center" *ngIf="data.type == 'prompt'">
        <button mat-raised-button (click)="onClick()">
          <mat-icon>arrow_right</mat-icon>
          <span>{{ button_save | translate }}</span>
        </button>
        <button mat-raised-button (click)="onNoClick()">
          <mat-icon>arrow_right</mat-icon>
          <span>{{ button_cancel | translate }}</span>
        </button>
      </div>
      <div style="width: 100%; text-align: center; display: flex;" *ngIf="data.type == 'confirm'">
        <br />
        <button mat-raised-button (click)="onClick()">
          <mat-icon>arrow_right</mat-icon>
          <span>{{ text_yes | translate }}</span>
        </button>
        <button mat-raised-button (click)="onNoClick()">
          <mat-icon>arrow_right</mat-icon>
          <span>{{ text_no | translate }}</span>
        </button>
      </div>
      <div *ngIf="data.type == 'alert'">
        <br />
        <button mat-raised-button (click)="onClick()">
          <mat-icon>arrow_right</mat-icon>
          <span>OK</span>
        </button>
      </div>
    </div>
  </div>
</div>